import React from "react";
import { Star, Languages, Plane, Award, ShieldCheck } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const TrustStrip = ({ variant = "dark" }) => {
    const { t } = useLanguage();

    const items = [
        { icon: Star, label: t.trust.stars },
        { icon: Languages, label: t.trust.bilingual },
        { icon: Plane, label: t.trust.airport },
        { icon: Award, label: t.trust.pmua },
        { icon: ShieldCheck, label: t.trust.licensed },
    ];

    const isDark = variant === "dark";

    return (
        <section
            data-testid="trust-strip"
            className={`${isDark ? "bg-[#3D3D24] text-[#FFFFF3]" : "bg-[#FFFFF3] text-[#3D3D24] border-y border-[#3D3D24]/15"} overflow-hidden`}
        >
            <div className="max-w-[1400px] mx-auto px-6 py-5 md:py-6">
                <div className="grid grid-cols-2 md:grid-cols-5 gap-5 md:gap-8 items-center">
                    {items.map(({ icon: Icon, label }, i) => (
                        <div
                            key={i}
                            data-testid={`trust-item-${i}`}
                            className="flex items-center gap-3 text-xs md:text-[13px] font-label tracking-[0.15em]"
                        >
                            <Icon
                                size={16}
                                className="text-[#D4A95A] shrink-0"
                                fill={Icon === Star ? "#D4A95A" : "none"}
                            />
                            <span className="opacity-90">{label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustStrip;
